<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Update Email Template Content</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="emailTemplateForm" style="width: 100%;">
            <div class="flex">
                <div class="innerdiv">
                  <div class="uploadsec" style="margin-right: 20px">
                    <div class="imgsec">
                      <img [src]="bannerImage ?  bannerImage :  '../../../../../assets/img/no_thumbnail.jpg'" alt="badge_image">
                    </div>
                    <div class="uploadbtnsec">
                      <input type="file" #image_one (change)="onImageUpload($event)" accept=".png, .jpg, .jpeg"
                        style="display:none">
                      <button type="button" class="uploadfilebtn" mat-raised-button (click)="image_one.click()">Upload image</button>
                    </div>
                  </div>
                </div>
              </div>

          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Image Link</mat-label>
              <input matInput placeholder="Url" formControlName="imageLink">
              <mat-error
                *ngIf="emailTemplateForm.controls['imageLink'].touched && emailTemplateForm.controls['imageLink'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error
                *ngIf="emailTemplateForm.controls['imageLink'].touched && emailTemplateForm.controls['imageLink'].hasError('pattern')">
                Please enter valid url.</mat-error>
            </mat-form-field>

            <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
              <mat-label><b>Sender and Receiver Details</b></mat-label>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Sender Name</mat-label>
                <input matInput placeholder="Sender Name" formControlName="senderName">
                <mat-error
                  *ngIf="emailTemplateForm.controls['senderName'].touched && emailTemplateForm.controls['senderName'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Sender Email</mat-label>
                <input matInput placeholder="Sender Email" formControlName="sentEmailFrom">
                  <mat-error
                    *ngIf="emailTemplateForm.controls['sentEmailFrom'].touched && emailTemplateForm.controls['sentEmailFrom'].hasError('required')">
                    This is a required field.</mat-error>
                    <mat-error
                    *ngIf="emailTemplateForm.controls['sentEmailFrom'].touched && emailTemplateForm.controls['sentEmailFrom'].hasError('pattern')">
                    Please enter valid email.</mat-error>
  
  
                </mat-form-field>
  
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Receiver Email</mat-label>
                <input matInput placeholder="Receiver Email" formControlName="replyToAddress">
                  <mat-error
                    *ngIf="emailTemplateForm.controls['replyToAddress'].touched && emailTemplateForm.controls['replyToAddress'].hasError('required')">
                    This is a required field.</mat-error>
                    <mat-error
                    *ngIf="emailTemplateForm.controls['replyToAddress'].touched && emailTemplateForm.controls['replyToAddress'].hasError('pattern')">
                    Please enter valid email.</mat-error>
  
  
                </mat-form-field>
              </div>
              
              
              
             
            </fxLayout>

            <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
              <mat-label><b>Above Image Text</b></mat-label>
              <ckeditor [config]="editorConfig" formControlName="aboveImageText" debounce="500"></ckeditor>
              <mat-error
              *ngIf="emailTemplateForm.controls['aboveImageText'].touched && emailTemplateForm.controls['aboveImageText'].hasError('required')" style="font-size:13px;">
              This is a required field.</mat-error>
            </fxLayout>
              
            <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
              <mat-label><b>Below Image Text</b></mat-label>
              <ckeditor [config]="editorConfig" formControlName="belowImageText" debounce="500"></ckeditor>
              <mat-error
              *ngIf="emailTemplateForm.controls['belowImageText'].touched && emailTemplateForm.controls['belowImageText'].hasError('required')" style="font-size:13px;">
              This is a required field.</mat-error>
            </fxLayout>

              <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
                <mat-label><b>Bottom Text</b></mat-label>
                <ckeditor [config]="editorConfig" formControlName="bottomText" debounce="500"></ckeditor>
                <mat-error
                *ngIf="emailTemplateForm.controls['bottomText'].touched && emailTemplateForm.controls['bottomText'].hasError('required')" style="font-size:13px;">
                This is a required field.</mat-error>
              </fxLayout>
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="updateTemplate()"><span>Update Content</span></button>
          </div>
          </form>
    </div>
  </div>
